import { redirectionTypes } from 'common/constants/buttonTypes'
import {
  backgroundPositionKeys,
  borderTypeKeys,
  buttonActionsTypes,
  defaultTextFontSize,
  widthNames,
} from 'common/constants/settings'
import structureTypes from 'common/constants/structureTypes'
import EntityTypeEnum from 'common/enums/entityTypeEnum'

export const entityBorderColors = {
  blue: '#149EFC',
  green: '#56C098',
  orange: '#F78828',
  gray: '#5A6E73',
}

export const translatableOptionKeys = [
  'text',
  'subText',
  'title',
  'subTitle',
  'errorText',
  'placeholder',
  'loadingText',
  'headerTitle',
  'loginHeadline',
  'registrationHeadline',
  'resettingHeadline',
  'resettingButtonText',
  'loginButtonText',
  'registrationButtonText',
  'emailLabel',
  'emailPlaceholder',
  'passwordLabel',
  'passwordPlaceholder',
  'passwordConfirmLabel',
  'passwordConfirmPlaceholder',
  'buttonText',
  'footerText',
  'buttonSubText',
  'subHeadline',
  'headline',
]

export const draftOptions = ['rawContentState']

export const appearanceSettings = {
  appearance: {
    desktop: true,
    mobile: true,
  },
}

export const defaultStyles = {
  [structureTypes.BUTTON]: {
    fontSize: '20px',
    borderTopLeftRadius: '3px',
    borderTopRightRadius: '3px',
    borderBottomRightRadius: '3px',
    borderBottomLeftRadius: '3px',
    color: 'rgba(255, 255, 255, 1)',
    background: 'rgba(1, 116, 199, 1)',
    padding: '15px 90px 15px 90px',
    marginTop: '25px',
    alignSelf: 'center',
    borderStyle: 'solid',
    borderWidth: '3px',
    borderColor: 'rgba(1,77,130,1)',
    marginBottom: '0px',
    marginLeft: '0px',
    marginRight: '0px',
    width: 'auto',
  },
  [structureTypes.SECTION]: {
    padding: '40px 40px 40px 40px',
    marginTop: '0px',
    marginBottom: '0px',
    marginLeft: '0px',
    marginRight: '0px',
  },
  [structureTypes.ROW]: {
    columnGap: '20px',
    padding: '10px 10px 10px 10px',
    marginTop: '0px',
    marginBottom: '0px',
    marginLeft: '0px',
    marginRight: '0px',
  },
  [structureTypes.FORM_INPUT]: {
    marginTop: '25px',
    fontSize: defaultTextFontSize,
    borderTopLeftRadius: '5px',
    borderTopRightRadius: '5px',
    borderBottomRightRadius: '5px',
    borderBottomLeftRadius: '5px',
    backgroundColor: 'rgba(255, 255, 255, 1)',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'rgba(176, 186, 202, 1)',
    marginBottom: '0px',
    marginLeft: '0px',
    marginRight: '0px',
  },
  [EntityTypeEnum.InlineBody]: {
    width: '400px',
  },
  [structureTypes.CONTENT_BOX]: {
    minHeight: '100px',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: 'rgba(85, 121, 195, 1)',
    padding: '10px',
    marginTop: '0px',
    marginBottom: '0px',
    marginLeft: '0px',
    marginRight: '0px',
  },
  [structureTypes.PAYMENT_BUTTON]: {
    borderStyle: 'none',
    borderWidth: '1px',
    fontSize: '20px',
    background: 'rgba(1, 116, 199, 1)',
    width: '100%',
    marginTop: '10px',
    marginBottom: '10px',
    marginLeft: '0px',
    marginRight: '0px',
    alignSelf: 'center',
  },
  [structureTypes.PHYSICAL_PRODUCT]: {
    padding: '10px 10px 10px 10px',
    marginTop: '0px',
    marginBottom: '0px',
    marginLeft: '0px',
    marginRight: '0px',
  },
  [structureTypes.LANGUAGE_SWITCHER]: {
    fontSize: '16px',
    color: 'rgba(149, 164, 186, 1)',
    marginTop: '0px',
    marginBottom: '0px',
    marginLeft: '0px',
    marginRight: '0px',
  },
}

export const defaultMobileStyles = {
  [structureTypes.CUSTOMER_TYPE]: {
    marginTop: '0px',
    marginBottom: '0px',
    marginLeft: '0px',
    marginRight: '0px',
  },
  [structureTypes.SECTION]: {
    padding: '5px 5px 5px 5px',
    marginTop: '0px',
    marginBottom: '0px',
    marginLeft: '0px',
    marginRight: '0px',
  },
  [structureTypes.ROW]: {
    padding: '5px 5px 5px 5px',
    marginTop: '0px',
    marginBottom: '0px',
    marginLeft: '0px',
    marginRight: '0px',
  },
  [EntityTypeEnum.InlineBody]: {
    padding: '5px 5px 5px 5px',
  },
  [structureTypes.BUTTON]: {
    fontSize: '20px',
    padding: '5px 5px 5px 5px',
    marginTop: '5px',
    marginBottom: '5px',
    marginLeft: '0px',
    marginRight: '0px',
    width: '100%',
    alignSelf: 'center',
    boxShadow: 'none',
  },
  [structureTypes.FORM_INPUT]: {
    marginTop: '10px',
    marginBottom: '0px',
    marginLeft: '0px',
    marginRight: '0px',
  },
  [structureTypes.PAYMENT_BUTTON]: {
    fontSize: '20px',
    padding: '5px 5px 5px 5px',
    marginTop: '5px',
    marginBottom: '5px',
    marginLeft: '0px',
    marginRight: '0px',
    width: '100%',
  },
  [structureTypes.CONTENT_BOX]: {
    padding: '10px 10px 10px 10px',
    marginTop: '0px',
    marginBottom: '0px',
    marginLeft: '0px',
    marginRight: '0px',
  },
  [structureTypes.PHYSICAL_PRODUCT]: {
    padding: '5px 5px 5px 5px',
    marginTop: '0px',
    marginBottom: '0px',
    marginLeft: '0px',
    marginRight: '0px',
  },
}

export const defaultOptions = {
  [structureTypes.SECTION]: {
    backgroundPosition: backgroundPositionKeys.noRepeat,
    width: widthNames.medium,
    ...appearanceSettings,
  },
  [structureTypes.BUTTON]: {
    borderType: borderTypeKeys.bottomOnly,
    action: buttonActionsTypes.sendForm,
    redirectionType: redirectionTypes.nextStep,
    text: 'entities.button.default_text',
    subText: 'entities.button.default_sub_text',
    subTextFontSize: '14px',
    subTextColor: 'rgba(255,255,255,0.8)',
    iconClassNameBefore: '',
    iconClassNameAfter: '',
    ...appearanceSettings,
  },
  [structureTypes.PAYMENT_BUTTON]: {
    borderType: borderTypeKeys.fullBorder,
    text: 'entities.payment_button.default_text',
    loadingText: 'entities.payment_button.default_loading_text',
    subTextFontSize: '14px',
    subTextColor: 'rgba(255,255,255,0.8)',
  },
  [structureTypes.CONTENT_BOX]: {
    headerTitle: 'entities.content_box.default_header_title',
    headerVisibility: '1',
    headerStyles: {
      color: 'rgba(255, 255, 255, 1)',
      backgroundColor: 'rgba(85, 121, 195, 1)',
      fontSize: '20',
      justifyContent: 'flex-start',
    },
    ...appearanceSettings,
  },
  [structureTypes.ROW]: {
    ...appearanceSettings,
  },
  [structureTypes.START_TIMER]: {
    timeStyles: {
      color: 'rgba(208, 2, 27, 1)',
      fontSize: 20,
    },
    labelStyles: {
      color: 'rgba(155, 155, 155, 1)',
      fontSize: 16,
    },
    ...appearanceSettings,
  },
  [structureTypes.FORM_INPUT]: {
    slug: null,
    ...appearanceSettings,
  },
  [structureTypes.PAYMENT_METHOD]: {
    ...appearanceSettings,
  },
  [structureTypes.CUSTOMER_TYPE]: {
    ...appearanceSettings,
  },
  [structureTypes.AGREEMENT]: {
    ...appearanceSettings,
  },
  [structureTypes.PHYSICAL_PRODUCT]: {
    ...appearanceSettings,
    attributeStyles: {
      fontSize: '14px',
    },
    attributeOptionStyles: {
      fontSize: '14px',
    },
    showQuantity: true,
  },
  [structureTypes.LANGUAGE_SWITCHER]: {
    redirectPath: '',
    excludedLanguages: [],
  },
}

export const defaultMobileOptions = {
  [structureTypes.CONTENT_BOX]: {
    headerStyles: {},
  },
  [structureTypes.START_TIMER]: {
    labelStyles: {
      fontSize: '14px',
      color: 'rgba(155, 155, 155, 1)',
    },
    timeStyles: {
      fontSize: '20px',
      color: 'rgba(208, 2, 27, 1)',
    },
  },
  [structureTypes.BUTTON]: {
    subTextFontSize: '14px',
  },
  [structureTypes.PAYMENT_BUTTON]: {
    subTextFontSize: '14px',
  },
  [structureTypes.PHYSICAL_PRODUCT]: {
    attributeStyles: {
      fontSize: '14px',
    },
    attributeOptionStyles: {
      fontSize: '14px',
    },
  },
}

export const editorZindex = {
  header: 40,
  sidebar: 35,
  colorPicker: 40,
  settingsOverlay: 30,
  colorPickerOverlay: 30,
  actionsMenu: 20,
  popupSettingsButton: 30,
  popupManagementOverlay: 10,
  actionsMenuItem: 10,
  colorPreview: 0,
}

export const mimeTypes = {
  image: ['image/*'],
  video: ['video/mp4', 'video/ogg', 'video/webm'],
  audio: [
    'audio/ogg',
    'audio/mpeg',
    'audio/mp3',
    'audio/wav',
    'audio/wave',
    'audio/x-wav',
    'audio/flac',
    'audio/x-flac',
  ],
  font: ['font/ttf'],
  all: [
    'image/*',
    'video/*',
    'audio/*',
    'application/*',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
    'application/vnd.apple.numbers',
    'application/pdf',
    'text/*',
  ],
}

export const upsellPricePlansStub = [
  {
    id: 3,
    name: 'entities.offer_upsell_price.stub.name',
    price: '1400 euro',
  },
]

export const pricePlansStub = [
  {
    id: 1,
    name: 'entities.offer_price.stub.name',
    currency: 'eur',
    type: 'limited_subscription',
    isLimited: true,
    subscriptionPlan: {
      amount: 800,
      interval: 'month',
      intervalCount: 1,
      trialPeriod: 30,
      trialInterval: 'day',
      limitOfPayments: 3,
    },
  },
  {
    id: 2,
    name: 'entities.offer_price.stub.name',
    currency: 'eur',
    type: 'one_shot',
    isLimited: false,
    directChargeAmount: 4750,
  },
  {
    id: 3,
    name: 'entities.offer_price.stub.name',
    currency: 'eur',
    type: 'subscription',
    isLimited: false,
    subscriptionPlan: {
      amount: 4350,
      interval: 'month',
      intervalCount: 1,
      trialPeriod: 0,
      limitOfPayments: null,
    },
  },
]

export const bumpStub = [
  {
    id: 1,
    pricePlans: [
      {
        id: 1,
        name: 'entities.offer_price.stub.name',
        subscriptionPlan: {
          amount: 800,
          interval: 'month',
          trialPeriod: 30,
          trialInterval: 'day',
          limitOfPayments: 3,
        },
      },
    ],
  },
]
